/* eslint-disable  */
import { debounce } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { format } from "timeago.js";
import { Search, ChevronRight, X } from "lucide-react";
import Loader from "../../Components/Loader";
import { dataActionCreators } from "../../services/Actions";
import RenderLoanPage from "../RenderLoanPage";
import { ToastContainer, toast } from "react-toastify";
import { GetUserProfile } from "../../services/Actions/authActions";

function InCompleteLoanApplication() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { GetIncompleteLoanApplications, ResetDataResponse } = bindActionCreators(
    dataActionCreators,
    dispatch
  );
  const [search, setSearch] = useState(null);
  const [openMessageModal, setOpenMessageModal] = useState(false);
  const [loanMessage, setLoanMessage] = useState("");

  const data = useSelector((state) => state?.data);
  const { appliedLoans, isLoading, response } = data;

  const onSearchTextChange = debounce((e) => {
    if (e?.target?.value) {
      setSearch(e?.target?.value ?? null);
    } else {
      setSearch(null);
    }
  }, 800);

  // Filter locally by search
  const filteredLoans = search
    ? appliedLoans?.filter(
      (loan) =>
        loan?.user?.name?.toLowerCase().includes(search.toLowerCase()) ||
        loan?.staff_id?.toLowerCase().includes(search.toLowerCase())
    )
    : appliedLoans;

  useEffect(() => {
    GetIncompleteLoanApplications();
  }, []);

  useEffect(() => {
    dispatch(GetUserProfile());
  }, []);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => ResetDataResponse(), 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetDataResponse(), 1500);
    }
  }, [response?.state]);

  return (
    <RenderLoanPage title="Incomplete Loans">
      {isLoading && <Loader />}

      {/* SEARCH BAR */}
      <div className="flex flex-col sm:flex-row gap-4 mb-6">
        <div className="flex-1">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
            <input
              type="search"
              placeholder="Search by Staff ID.."
              className="w-full pl-10 pr-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent shadow-sm"
              onChange={onSearchTextChange}
            />
          </div>
        </div>
      </div>

      {/* TABLE */}
      <section className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">


        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="dark:bg-gray-800 bg-slate-50">
                <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Member Info</th>
                <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Loan Amount</th>
                <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Date</th>
                <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Status</th>
                <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Sector</th>
                <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider text-right">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {filteredLoans?.length > 0 ? (
                filteredLoans.map((loan) => (
                  <tr key={loan?._id} className="hover:bg-slate-50/80 transition-colors">
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <img className="w-10 h-10 rounded-full border border-slate-200 object-cover shadow-sm" src={loan?.user?.profile_image || "/images/dev/avatar1.png"} alt="Profile" />
                        <div>
                          <p className="text-sm font-bold text-slate-800 leading-tight">{loan?.user?.name}</p>
                          <p className="text-xs font-medium text-slate-500">{loan?.staff_id}</p>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-emerald-50 text-emerald-700 border border-emerald-100">&#8373;{loan?.loanAmount}</span>
                      <p className="text-xs text-slate-400 mt-1">MD: {loan?.monthlyDeduction}</p>
                    </td>
                    <td className="px-6 py-4">
                      <p className="text-sm text-slate-600 font-medium">{moment(loan?.created_at).format("MMM DD, YYYY")}</p>
                      <p className="text-xs text-slate-400">{format(loan?.updated_at)}</p>
                    </td>
                    <td className="px-6 py-4">
                      <button
                        onClick={() => {
                          setLoanMessage(loan?.incomplete[0]?.message);
                          setOpenMessageModal(true);
                        }}
                        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-amber-50 text-amber-700 border border-amber-100 cursor-pointer hover:bg-amber-100 transition-colors"
                      >
                        View rejected message
                      </button>
                    </td>
                    <td className="px-6 py-4">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${loan?.sector === "Northern" ? "bg-red-50 text-red-700 border-red-100" : "bg-blue-50 text-blue-700 border-blue-100"}`}>{loan?.sector}</span>
                    </td>
                    <td className="px-6 py-4 text-right">
                      <button onClick={() => history.push({ pathname: "/loans/loan-detailed", state: { loan_id: loan?._id } })} className="p-2 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-all">
                        <ChevronRight size={20} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="px-6 py-12 text-center text-slate-400 italic">No incomplete loans at the moment.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>

      {/* MODERN MODAL */}
      {openMessageModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-[9998] p-4">
          <div className="relative z-[9999] bg-white rounded-2xl shadow-2xl max-w-[90vw] max-h-[90vh] overflow-hidden" style={{ width: "40%" }}>
            {/* Header */}
            <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex justify-between items-center z-10">
              <h3 className="text-xl font-bold text-black">Rejected Loan Application</h3>
              <button
                type="button"
                className="w-10 h-10 rounded-full bg-gray-100 hover:bg-red-100 text-gray-500 hover:text-red-500 flex items-center justify-center transition-all duration-200"
                onClick={() => setOpenMessageModal(false)}
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            {/* Content */}
            <div className="p-6">
              <p className="text-slate-600 text-sm leading-relaxed">
                {loanMessage === "" ? "No message was attached. Please contact your loans head." : loanMessage}
              </p>
              <div className="mt-6 flex justify-end">
                <button
                  type="button"
                  onClick={() => setOpenMessageModal(false)}
                  className="px-5 py-2.5 bg-rose-600 hover:bg-rose-700 text-white font-semibold rounded-xl text-sm transition-colors shadow-sm"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer autoClose={3000} />
    </RenderLoanPage>
  );
}

export default InCompleteLoanApplication;
